<template>
  <b-field :type="isInvalid ? 'is-danger' : ''" :message="isInvalid ? validationMessage : ''">
    <b-input
      v-model="inputValue"
      :type="type"
      :size="size"
      :maxlength="maxlength"
      :placeholder="placeholder"
      :pattern="pattern"
      @input="validateInput"
      @blur="validateInput"
      :data-label="dataLabel"
      pattern-validate
    ></b-input>
  </b-field>
</template>

<script>
export default {
  name: 'CustomTextarea',

  props: {
    value: String,
    type: {
      type: String,
      default: 'textarea',
    },
    maxlength: Number,
    placeholder: String,
    pattern: String,
    validationMessage: {
      type: String,
      default: 'Please remove any invalid characters.',
    },
    dataLabel:{
        type: String,
        default: 'text area'
    },
    size:{
        type: String,
        default: 'is-small'
    }
  },
  data() {
    return {
      inputValue: this.value,
      isInvalid: false,
    };
  },
  watch: {
    inputValue(newValue) {
      this.$emit('input', newValue);
    },
  },
  methods: {
    validateInput() {
      if (this.inputValue.trim() === '') {
        this.isInvalid = false;
      } else if (this.pattern) {
        const regex = new RegExp(this.pattern);
        this.isInvalid = !regex.test(this.inputValue);
      }
    },
  },
};
</script>

<style scoped>
.is-danger {
  border-color: #ff3860;
}
</style>
